import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Nav, Tab, Form, ListGroup, Button, Modal, ProgressBar, Card } from 'react-bootstrap';
import smsPic from "../../assets/img/mobileScreens/SMS.png"
import { WhatsappTemplateComponent } from "./WhatsappComponent";
import { RcsTemplateComponent } from "./RcsTabManagement/RcsTemplateComponent";
import { useCreateSMSTemplateMutation } from "Services/services";
import moment from "moment-timezone";
import { CheckCircleIcon, ClockIcon, ShieldExclamationIcon } from "@heroicons/react/solid";
import { IoMdAddCircle } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { Routes } from "routes";
import SmsCalculator from "pages/SmsCalculator";
import EmojiPicker from "emoji-picker-react";
import Select from 'react-select';
import { useLocation } from "react-router-dom";
import { BsEmojiSmile } from "react-icons/bs";

export default () => {
    // // Get the user type from localStorage :: UI
    // const userData = localStorage.getItem("TOKEN");
    // const userObject = JSON.parse(userData);
    // const international = userObject.country==="Saudi Arabia"||userObject.country==="United Arab Emirates";
    const location = useLocation();
    const defaultTab = 'SMS';
    const tabFromState = location.state?.tab || defaultTab;

    const [activeKey, setActiveKey] = useState(tabFromState);

    // comment
    const [showModal, setShowModal] = useState(false);
    const [progress, setProgress] = useState(0);
    const [reason, setReason] = useState('');
    const [variant, setVariant] = useState('primary');
    const history = useHistory();
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const emojiPickerRef = useRef(null);
    const [smsDetails, setSmsDetails] = useState({
        textLength: 0,
        remaining: 0,
        numberOfSMS: 1,
        encoding: 'GSM 7'
    });

    // Options for react-select components
    const categoryOptions = [
        { value: "PROMOTIONAL", label: "PROMOTIONAL" },
        { value: "TRANSACTIONAL", label: "TRANSACTIONAL" },
        { value: "OTP", label: "OTP" },
    ];

    const languageOptions = [
        { value: "English", label: "English" },
        { value: "english", label: "english" },
        { value: "hindi", label: "hindi" },
        { value: "punjabi", label: "punjabi" },
    ];


    // This will return the form inputs
    const formRef = useRef(null);
    const handleCloseModal = () => {
        setShowModal(false);
        setTimeout(() => {
            setProgress(0);
        }, 100);
        setReason('');
        setVariant('primary');
    };
    // This will reset the form inputs
    const handleRefresh = () => {
        if (formRef.current) {
            formRef.current.reset();
        }
        setValidated(false);
        setShowModal(false);
        setTimeout(() => {
            setProgress(0);
        }, 100);
        history.push({
            pathname: Routes.Templates.path,
            state: { tab: "SMS" }
        });
        setReason('');
        setVariant('primary');
    };
    useEffect(() => {
        if (showModal) {
            const interval = setInterval(() => {
                setProgress(prevProgress => {
                    if (prevProgress >= 100) {
                        clearInterval(interval);
                        return 100;
                    }
                    return Math.min(prevProgress + 5, 95);
                });
            }, 100);
        }
    }, [showModal]);

    // Toggle the emoji picker visibility
    const toggleEmojiPicker = () => {
        setShowEmojiPicker((prev) => !prev);
    };

    // Append emoji to the message field in form state
    const handleEmojiClick = (emojiData) => {
        const emoji = emojiData.emoji; // Get the emoji character
        setFormValues((prevValues) => ({
            ...prevValues,
            template_content: (prevValues.template_content || '') + emoji // Append emoji to the message field
        }));
    };

    // Effect to handle clicks outside the emoji picker
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
                setShowEmojiPicker(false); // Close emoji picker if clicked outside
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleCalculation = ({ textLength, remaining, numberOfSMS, encoding }) => {
        setSmsDetails({ textLength, remaining, numberOfSMS, encoding });
    };

    const [formValues, setFormValues] = useState({
        category: "PROMOTIONAL",
    });
    const [createTemp] = useCreateSMSTemplateMutation();
    const handleChange = (e) => {
        setFormValues((prevValues) => ({
            ...prevValues,
            [e.target.name]: e.target.value,
            language: "En"
        }));
    };

    const handleSelectChange = (selectedOption, actionMeta) => {
        setFormValues((prevValues) => ({
            ...prevValues,
            [actionMeta.name]: selectedOption ? selectedOption.value : "",
            language: "En"
        }));
    };

    //add variables
    const textareaRef = useRef(null);
    const [count, setCount] = useState(1);
    const AddAuthVars = () => {
        const textarea = textareaRef.current;

        const varToAdd = `{{${count}}}`;

        // Get the cursor position
        const startPos = textarea.selectionStart;
        const endPos = textarea.selectionEnd;

        // Get current textarea content (which could be empty)
        const currentContent = formValues.template_content || ""; // Handle empty string case

        // Insert the variable at the cursor position
        const updatedValue =
            currentContent.substring(0, startPos) +  // Everything before the cursor
            varToAdd +                              // The variable to insert
            currentContent.substring(endPos);        // Everything after the cursor

        // Update the state with the new value
        setFormValues({ ...formValues, template_content: updatedValue });

        // Maintain the cursor position after insertion
        setTimeout(() => {
            textarea.selectionStart = textarea.selectionEnd = startPos + varToAdd.length;
            textarea.focus();
        }, 0);

        setCount(prevCount => prevCount + 1);
    };

    //post
    const [validated, setValidated] = useState(false);
    const submitSMS = (e) => {
        // Prevent the default form submission
        e.preventDefault();

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }

        setShowModal(true);
        createTemp(formValues)
            .then((success) => {
                if (success?.data?.statusCode >= 200 && success?.data?.statusCode <= 204) {
                    setReason(success?.data?.message);
                    setVariant('tertiary');
                    setProgress(100);
                } else if (success?.data?.statusCode > 300) {
                    setReason(success?.data?.data?.errorMessage ||success?.data?.message || 'Upload failed!');
                    setVariant('warning');
                    setProgress(100);
                }
            })
            .catch((error) => {
                setReason(error?.message || 'Upload failed');
                setVariant('warning');
                setShowModal(true);
                setProgress(100);
            });
    }

    //preview
    const date = moment();
    const currentTime = date.format("[Today], h:mm A");
    const highlightTemplateContent = (content) => {
        const parts = content.split(/(\{\{\d+\}\})/);
      
        return parts.map((part, index) => {
          if (/\{\{\d+\}\}/.test(part)) {
            return (
              <span key={index} style={{ color: "blue" }}>
                {part}
              </span>
            );
          }
      
          return (
            <span key={index} style={{ whiteSpace: "pre-wrap" }}>
              {part}
            </span>
          );
        });
      };




    return (
        <div style={{margin: '12px'}}>

            <Tab.Container defaultActiveKey={activeKey} onChange={setActiveKey}>
                <Row>
                    <Col xl={2} className="pe-xl-0">
                        <Card className="p-2 m-0">
                            <Nav fill variant="pills" className="d-flex flex-row flex-xl-column vertical-tab gap-2">
                                <Nav.Item>
                                    <Nav.Link eventKey="SMS" className="mb-0">
                                        SMS
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="WhatsApp" className="mb-0">
                                        WhatsApp
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="RCS" className="mb-0">
                                        RCS
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Card>
                    </Col>
                    <Col xl={10}>
                        <Tab.Content className="my-2 m-xl-0 mb-2 mb-md-0">
                            <Tab.Pane eventKey="SMS">
                                <div className="d-flex flex-row-reverse flex-wrap flex-sm-nowrap gap-3">
                                    {/* preview */}
                                    <div className="img-cont">
                                            <img src={smsPic} alt="sms preview" />
                                            <div className="preview-name">
                                                <span className="sender">{formValues.header}</span>
                                            </div>
                                            <div className="preview-cont">
                                                <div className="time_box">
                                                    <span>SMS</span>
                                                    <span>{currentTime}</span>
                                                </div>
                                                {formValues.template_content && <div id="smsBody">
                                                    <span>{highlightTemplateContent(formValues.template_content)}</span>
                                                </div>}
                                            </div>
                                    </div>
                               
                               {/* formfields */}
                                    <Form noValidate validated={validated} ref={formRef} onSubmit={submitSMS} className="w-100">
                                            <div className="mid-section-scroll">
                                            <div className="card p-3 m-0">
                                                <p className="m-0">
                                                    <b>Note:</b> Template creation here is limited to India. For other countries, please create templates during the campaign setup process.
                                                </p>
                                                <Row className="mt-3">
                                                    <Form.Group as={Col} lg={6} className="withChars mb-3">
                                                        <Form.Label>Template Name  <span className="text-danger"> * </span></Form.Label>
                                                        <Form.Control type="text" required placeholder="Enter Template Name" maxLength={100} name="template_name" 
                                                        value={formValues.template_name}
                                                        onChange={(e)=>{
                                                            const val=e.target.value;
                                                            if (/^[a-z0-9]{0,100}$/.test(val)){
                                                                setFormValues((prev)=>({
                                                                    ...prev,
                                                                    template_name: val,
                                                                }))
                                                            };
                                                           
                                                        }} 
                                                        title="Max 100 characters lowercase aplhanumeric" />
                                                        <p className="chars_count">{formValues.template_name === undefined ? "0" : formValues.template_name.length}/100</p>
                                                        {validated && !formValues.template_name && (
                                                            <div className="invalid-feedback d-block">
                                                              Enter a valid Template Name.
                                                            </div>
                                                          )}
                                                    </Form.Group>
                                                    <Form.Group as={Col} lg={6} className="mb-3">
                                                        <Form.Label>Category <span className="text-danger"> * </span></Form.Label>
                                                        <Select
                                                            name="category"
                                                            onChange={handleSelectChange}
                                                            options={categoryOptions}
                                                            value={categoryOptions.find(option => option.value === formValues.category)}
                                                            placeholder="Select Category"
                                                            styles={{
                                                                control: (provided, state) => ({
                                                                  ...provided,
                                                                  borderColor: validated && !formValues.category ? '#dc3545' :  validated && formValues.category ? '#65BB82': '#ced4da',
                                                                  borderRadius: '0.75rem',
                                                                }),
                                                              }}
                                                        />
                                                          {validated && !formValues.category && (
                                                            <div className="invalid-feedback d-block">
                                                              Category selection is required.
                                                            </div>
                                                          )}
                                                    </Form.Group>
                                                    <Form.Group as={Col} lg={6} className="mb-3">
                                                        <Form.Label>Language <span className="text-danger"> * </span></Form.Label>
                                                        <Select
                                                            isDisabled={true}
                                                            options={languageOptions}
                                                            value={languageOptions.find(option => option.value === "English")}
                                                            placeholder="Select Language"
                                                            styles={{
                                                                control: (provided, state) => ({
                                                                  ...provided,
                                                                //   borderColor: validated && !formValues.language ? '#dc3545' :  validated && formValues.language ? '#65BB82': '#ced4da',
                                                                  borderColor: validated ? '#65BB82': '#ced4da',
                                                                  borderRadius: '0.75rem',
                                                                }),
                                                              }}
                                                        />
                                                         {/* {validated && !formValues.language && (
                                                            <div className="invalid-feedback d-block">
                                                              Language selection is required.
                                                            </div>
                                                          )} */}
                                                    </Form.Group>
                                                    <Form.Group as={Col} lg={6} className="withChars mb-3">
                                                        <Form.Label>Sender ID <span className="text-danger"> * </span></Form.Label>
                                                        <Form.Control type="text" required placeholder="Enter Sender ID" maxLength={11} name="header" onChange={handleChange} />
                                                        <p className="chars_count">{formValues.header === undefined ? "0" : formValues.header.length}/11</p>
                                                        {validated && !formValues.header && (
                                                            <div className="invalid-feedback d-block">
                                                              Enter a valid Sender ID.
                                                            </div>
                                                          )}
                                                    </Form.Group>

                                                    <Form.Group as={Col} lg={6} className="withChars mb-3">
                                                        <Form.Label>PE ID <span className="text-danger"> * </span></Form.Label>
                                                        <Form.Control type="text" required placeholder="Enter PE ID" maxLength={19} name="pe_id" value={formValues.pe_id} onChange={handleChange} />
                                                        <p className="chars_count">{formValues.pe_id === undefined ? "0" : formValues.pe_id.length}/19</p>
                                                        {validated && !formValues.pe_id && (
                                                            <div className="invalid-feedback d-block">
                                                              Enter a valid PE ID.
                                                            </div>
                                                          )}
                                                    </Form.Group>
                                                    <Form.Group as={Col} lg={6} className="withChars mb-3">
                                                        <Form.Label>Template ID <span className="text-danger"> * </span></Form.Label>
                                                        <Form.Control type="text" required placeholder="Enter Template ID" maxLength={19} name="template_id" onChange={handleChange} />
                                                        <p className="chars_count">{formValues.template_id === undefined ? "0" : formValues.template_id.length}/19</p>
                                                        {validated && !formValues.template_id && (
                                                            <div className="invalid-feedback d-block">
                                                              Enter a valid Template ID.
                                                            </div>
                                                          )}
                                                    </Form.Group>

                                                    <Form.Group as={Col} lg={6} className="withChars mb-3">
                                                        <Form.Label>Telemarketer ID <span className="text-danger"> * </span></Form.Label>
                                                        <Form.Control type="text" required placeholder="Enter Telemarketer ID" maxLength={19} name="telemarketer_id" onChange={handleChange} />
                                                        <p className="chars_count">{formValues.telemarketer_id === undefined ? "0" : formValues.telemarketer_id.length}/19</p>
                                                        {validated && !formValues.telemarketer_id && (
                                                            <div className="invalid-feedback d-block">
                                                              Enter a valid Telemarketer ID.
                                                            </div>
                                                          )}
                                                    </Form.Group>
                                                </Row>
                                                <Form.Group className="mb-3 withChars">
                                                    <div className="d-flex align-items-center">
                                                        <Form.Label>Content Body <span className="text-danger"> * </span></Form.Label>
                                                        <button
                                                            type="button"
                                                            className="ms-auto emojiPicker me-2"
                                                            onClick={toggleEmojiPicker}
                                                        >
                                                            <BsEmojiSmile />
                                                        </button>

                                                        {showEmojiPicker && (
                                                            <div
                                                                ref={emojiPickerRef}
                                                                className="emojiPickerBox"
                                                            >
                                                                <EmojiPicker onEmojiClick={handleEmojiClick} />
                                                            </div>
                                                        )}
                                                        <Button onClick={AddAuthVars} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} className="d-flex align-items-center text-info fw-bold">
                                                            <IoMdAddCircle className="icon icon-xs me-2" /><span>Add Variable</span>
                                                        </Button>
                                                    </div>
                                                    {/* <Form.Control as="textarea" rows="15" required placeholder="Enter Message Content" name="template_content" value={formValues.template_content} onChange={handleChange} ref={textareaRef} /> */}
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={10}
                                                        required
                                                        placeholder="Enter Message Content"
                                                        name="template_content" // Ensure this matches the state field you are updating
                                                        value={formValues.template_content} // Bind textarea value to message state
                                                        onChange={handleChange} // Handle input changes
                                                        ref={textareaRef}
                                                    />
                                                    <p className="chars_count ta">{formValues.template_content === undefined ? "0" : formValues.template_content.length}</p>
                                                    {validated && !formValues.template_content && (
                                                            <div className="invalid-feedback d-block">
                                                              Enter a valid Template Content.
                                                            </div>
                                                          )}

                                                </Form.Group>
                                                <SmsCalculator
                                                    text={formValues.template_content || ""}
                                                    onCalculation={handleCalculation} // Pass the callback to SmsCalculator
                                                />
                                                <ListGroup horizontal className="border-0 flex-wrap ms-auto">
                                                    <ListGroup.Item className="font-size-xs" variant="info">Encoding:{smsDetails.encoding}</ListGroup.Item>
                                                    <ListGroup.Item className="font-size-xs" variant="info">Character Count: {smsDetails.textLength}/{smsDetails.remaining}</ListGroup.Item>
                                                    <ListGroup.Item className="font-size-xs" variant="info">SMS Segments: {smsDetails.numberOfSMS}</ListGroup.Item>
                                                </ListGroup>
                                            </div>
                                            <div className="d-flex mt-3 justify-content-end">
                                                {/* <Button variant="secondary" type="button" className="animate-up-2 me-2" >
                                                    Verify
                                                </Button> */}
                                                <Button variant="secondary" type="submit" className="animate-up-2">
                                                    Submit
                                                </Button>
                                            </div>
                                            </div>
                                    </Form>
                                       
                                </div>

                                    <Modal
                                        centered
                                        show={showModal}
                                        onHide={handleCloseModal}
                                        className={`modal-${variant}`}
                                        backdrop="static"
                                        keyboard={false}
                                    >
                                        <Modal.Header className="mx-auto">
                                            <p className="lead mb-0 text-white">Creating SMS Template</p>
                                        </Modal.Header>
                                        <Modal.Body className="pt-0">
                                            <div className="py-3 px-5 text-center">
                                                {progress !== 100 ?
                                                    (<span className="modal-icon display-1">
                                                        <ClockIcon className="icon icon-xl text-white" />
                                                    </span>) :
                                                    variant === 'tertiary' ?
                                                        (<span className="modal-icon display-1">
                                                            <CheckCircleIcon className="icon icon-xl text-white" />
                                                        </span>) :
                                                        <span className="modal-icon display-1">
                                                            <ShieldExclamationIcon className="icon icon-xl text-white" />
                                                        </span>
                                                }

                                                <Modal.Title className="text-white mb-3">
                                                    {progress !== 100 ? <h3>Sending Request</h3> : variant === 'tertiary' ? <h3>Template Created Successfully</h3> : <h3>Something Went Wrong</h3>}
                                                </Modal.Title>
                                                <ProgressBar variant="secondary" now={progress} min={0} max={100} animated />
                                                {variant !== 'tertiary' ?
                                                    <p className="mb-4 text-danger">
                                                        {reason}
                                                    </p> : ''}
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer className="d-flex justify-content-center pt-0 pb-3">
                                            <Button variant="white" size="sm" className="text-primary fw-bold" onClick={handleRefresh}>
                                                OK
                                            </Button>
                                            {variant !== 'tertiary' && <Button variant="white" size="sm" className="text-primary fw-bold" onClick={handleCloseModal}>
                                                Retry
                                            </Button>}
                                        </Modal.Footer>
                                    </Modal>
                                {/* </Row> */}
                            </Tab.Pane>

                            <Tab.Pane eventKey="WhatsApp">
                                <WhatsappTemplateComponent />
                            </Tab.Pane>

                            <Tab.Pane eventKey="RCS">
                                <RcsTemplateComponent />
                            </Tab.Pane>
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        </div>
    );
};
